import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    ChipField,
    ShowButton,
    ReferenceManyField,
    Pagination,
    useListContext,
} from 'react-admin';
import CityField from '../../components/CityField';
import { Chip } from '@material-ui/core';
import { FunctionField } from 'react-admin';
import humanize from '../../util/humanize';

const DatagridWithTotal = props => {
    const { total, loaded } = useListContext();

    return (
        <>
            {loaded && (
                <div
                    style={{
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgba(0, 0, 0, 0.87)',
                    }}
                >
                    Total Requests: {total || 0}
                </div>
            )}
            <Datagrid>
                <TextField source="serial" sortable={false} />
                <DateField locales="en-IN" source="date" />
                <TextField source="status" />
                {/*}ChipField source="type" />*/}
                <FunctionField
                    label="Type"
                    render={record => {
                        return <Chip label={humanize(record.type)} />;
                    }}
                />
                <CityField />
                <ShowButton />
            </Datagrid>
            <Pagination />
        </>
    );
};

export const OrderRequestsList = props => (
    <ReferenceManyField
        reference="requests"
        target="orderId"
        perPage={25}
        filter={{ orderId: props.record.id }}
        {...props}
    >
        <DatagridWithTotal />
    </ReferenceManyField>
);
